import { Box } from "@chakra-ui/layout";
export default function PostTitle({ children }) {
    return (
      <Box as='h1'  className="post-title">
        {children}
      </Box>
    )
  }
  